var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "kpiListContainer", staticClass: "kpi-list__container" },
    [
      _c(
        "div",
        { ref: "kpiListWrapper", staticClass: "kpi-list__wrapper" },
        [
          _vm.kpis.length
            ? _vm._l(_vm.getKPIMapGroups, function(group, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    ref: "kpiList",
                    refInFor: true,
                    class: _vm.listClass
                  },
                  [
                    _vm._l(group, function(kpi) {
                      return [
                        kpi.type === "item"
                          ? _c(
                              "KPIItem",
                              _vm._b(
                                { key: kpi.name },
                                "KPIItem",
                                _vm.getFormattedKpi(kpi),
                                false
                              )
                            )
                          : kpi.type === "progress"
                          ? _c(
                              "KPIProgressBar",
                              _vm._b(
                                {
                                  key: kpi.name + "-" + kpi.type + "-" + index,
                                  attrs: {
                                    label: _vm.$t.__("common.labels.progress"),
                                    highLimit: 74.99,
                                    lowLimit: 24.99
                                  }
                                },
                                "KPIProgressBar",
                                _vm.getFormattedKpi(kpi),
                                false
                              )
                            )
                          : kpi.type === "warning"
                          ? _c("KPIWarning", {
                              key: kpi.name + "-" + index,
                              attrs: { label: kpi.formatted }
                            })
                          : _vm._e()
                      ]
                    })
                  ],
                  2
                )
              })
            : _vm._l(2, function(_, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    ref: "kpiList",
                    refInFor: true,
                    staticClass: "kpi-list"
                  },
                  _vm._l(4, function(_, i) {
                    return _c(
                      "div",
                      { key: i, staticClass: "kpi-list__skeleton-item" },
                      [
                        _c("CompassSkeleton", {
                          staticClass: "kpi-list__skeleton--header"
                        }),
                        _vm._v(" "),
                        _c("CompassSkeleton", {
                          staticClass: "kpi-list__skeleton--value",
                          attrs: { size: "large" }
                        })
                      ],
                      1
                    )
                  }),
                  0
                )
              })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showLeftShadow,
              expression: "showLeftShadow"
            }
          ],
          ref: "shadowLeft",
          staticClass:
            "kpi-list__navigation-button kpi-list__navigation-button--left"
        },
        [
          _c(
            "button",
            {
              staticClass: "kpi-list__scroll-button",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.handleScroll("left")
                }
              }
            },
            [
              _c("CompassIcon", {
                attrs: { icon: "caret-left", size: "extra-small" }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showRightShadow,
              expression: "showRightShadow"
            }
          ],
          ref: "shadowRight",
          staticClass:
            "kpi-list__navigation-button kpi-list__navigation-button--right"
        },
        [
          _c(
            "button",
            {
              staticClass: "kpi-list__scroll-button",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.handleScroll("right")
                }
              }
            },
            [
              _c("CompassIcon", {
                attrs: { icon: "caret-right", size: "extra-small" }
              })
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }